import _ from 'lodash'

// The precision to round to
const PRECISION = 2

export const convert = ({
  quantity,
  unit,
  units,
  toBase = false,
  precision = PRECISION
}) => {
  const val = parseFloat(quantity)
  const round = x => (precision === false ? x : _.round(x, precision))

  if (!_.isNumber(val)) {
    throw new TypeError('quantity is not a number')
  }
  if (!unit) {
    throw new TypeError('unit is required')
  }
  if (!units) {
    throw new TypeError('units is required')
  }

  const findUnit = ({ synonyms = [], ...u }) =>
    _.some([u.unit, ...synonyms], x => x === unit)

  const actualUnit = units.find(findUnit)
  if (!actualUnit) {
    throw new TypeError('unit is not in units list')
  }

  const multiplyer = parseFloat(actualUnit.conversion)
  const isDefaultUnit = _.findIndex(units, actualUnit) === 0

  if (!actualUnit.conversion || isDefaultUnit) {
    return round(val)
  }

  const result = toBase
    ? _.divide(val, multiplyer)
    : _.multiply(val, multiplyer)

  return round(result)
}

export const normalizeLabReport = labReport => {
  if (!labReport) return {}
  const { lab, date, errorResults } = labReport
  let { results } = labReport
  results = results.map(biomarker => {
    const { id, text, quantity, unit, units } = biomarker

    return {
      biomarker: id,
      text,
      quantity:
        units.length > 0
          ? convert({
              quantity,
              unit,
              units
            })
          : null,
      unit
    }
  })
  if (errorResults) {
    errorResults.forEach(biomarker => {
      const { id, text, quantity, unit, units } = biomarker
      if (!id || !unit) return
      results.push({
        biomarker: id,
        text,
        quantity:
          units.length > 0
            ? convert({
                quantity,
                unit,
                units
              })
            : null,
        unit
      })
    })
  }

  return {
    lab,
    date,
    results
  }
}

export const denormalizeLabReport = labReport => {
  if (!labReport) return {}
  const { _id, date, lab, results } = labReport

  return {
    _id,
    date: new Date(date),
    lab,
    results: results.map(({ biomarker, text, quantity, unit }) => ({
      ...biomarker,
      text,
      quantity:
        biomarker.units.length > 0
          ? convert({
              quantity,
              unit,
              toBase: true,
              units: biomarker.units
            })
          : null,
      unit
    }))
  }
}
